<template>
    <!-- In place of the upgrades, for a kit whose sample will never give results -->
    <div class="upgrades-unavailable text-start">
        <h3 class="upgrades-unavailable__title">Upgrades aren't available for kit {{ barcode }}</h3>
        <p v-if="status === 'testing_failed' && isUpload" class="mb-0">
            We couldn't process the DNA file uploaded for this kit, so an upgrade would have no results to add to.
            Contact <a class="fw-semibold" href="mailto:help@livingdna.com">help@livingdna.com</a> and we'll help.
        </p>
        <template v-else-if="status === 'testing_failed'">
            <p>
                We couldn't get a reliable result from this kit's sample, so an upgrade would have no results to
                add to. Once you've sent us a new sample and it has been tested, you can upgrade the new kit.
            </p>
            <router-link :to="{ name: 'new-sample-kit', params: { barcode } }" class="btn btn-primary">
                Request a new sample kit
            </router-link>
        </template>
        <template v-else-if="status === 'transfer_qc_failed'">
            <p>
                The DNA file uploaded for this kit didn't pass our checks, so an upgrade would have no results to
                add to. Upload the file again and you can upgrade once it has been processed.
            </p>
            <router-link :to="{ name: 'reupload-dna', params: { barcode } }" class="btn btn-primary">
                Upload your DNA file again
            </router-link>
        </template>
        <p v-else class="mb-0">
            This kit was cancelled, so it won't have results to upgrade. If you think that's wrong, contact
            <a class="fw-semibold" href="mailto:help@livingdna.com">help@livingdna.com</a>.
        </p>
    </div>
</template>

<script setup>
import { computed, defineProps } from "vue";

const props = defineProps({
    barcode: { type: String, required: true },
    // A status from statusWithoutResults: testing_failed, transfer_qc_failed or cancelled.
    status: { type: String, required: true },
});

// An LT barcode is an uploaded DNA file: there's no sample to send again.
const isUpload = computed(() => props.barcode.toUpperCase().startsWith("LT"));
</script>

<style lang="scss" scoped>
.upgrades-unavailable {
    max-width: 720px;
    margin: 24px auto;
    padding: 24px 28px;
    border-radius: 16px;
    background: #fff;
    border-left: 4px solid #e39a1c;
    box-shadow: 0 4px 20px rgba(26, 31, 54, 0.06);

    p {
        font-size: 15px;
        line-height: 1.6;
        color: #4a5472;
    }
}

.upgrades-unavailable__title {
    font-size: 18px;
    font-weight: 600;
    color: #1a1f36;
    margin: 0 0 10px;
}
</style>
